import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';
import COLORS_MARKETPLACE from '../constants/COLORS_MARKETPLACE';

import mixins from './mixins';

export default {
  Global: createGlobalStyle`

  html {
    -ms-touch-action: manipulation;
    touch-action: manipulation;
  }

  button {
    -ms-touch-action: manipulation;
    touch-action: manipulation;
  }

  html, body {
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0px;
    text-rendering: optimizelegibility;
    -webkit-font-smoothing: antialiased;
    text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    font-family: 'Roboto', sans-serif;
    background: #fff;
  }

  .grecaptcha-badge {
    display: none !important;
  }

  .grabbing {
    cursor: grabbing;
  }

  canvas {
    position: absolute;
    left: 0;
    top: 0;
  }
`,
};

export const AnnouncementsGlobalStyles = {
  Global: createGlobalStyle`
  ${normalize}

  ${mixins.fonts}

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  html {
    box-sizing: border-box;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
  }

  html, body {
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0px;
    text-rendering: optimizelegibility;
    -webkit-font-smoothing: antialiased;
    text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  body {
    min-width: 320px;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    line-height: 1.4;
    color: ${COLORS_MARKETPLACE.BLACK};
  }

  a {
    text-decoration: none;
  }

  button {
    -ms-touch-action: manipulation;
    touch-action: manipulation;
  }

  canvas {
    position: absolute;
    left: 0;
    top: 0;
  }

  .grabbing {
    cursor: grabbing;
  }

  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
    white-space: nowrap;
    overflow: hidden;
    clip: rect(0 0 0 0);
  }

  .visually-hidden.focusable:active,
  .visually-hidden.focusable:focus {
    position: static;
    width: auto;
    height: auto;
    margin: 0;
    overflow: visible;
    white-space: inherit;
    clip: auto;
  }

  .scroll-lock {
    overflow: hidden;
    position: relative;
    height: 100%;
  }
`,
};
